(function () {
	'use strict';

	const header = document.querySelector('.site-header');
	const burger = header ? header.querySelector('.site-header__burger') : null;
	const mobileMenu = header ? header.querySelector('.site-header__mobile-menu') : null;

	if (!header) {
		return;
	}

	const isFront = document.body.classList.contains('front-page') || document.body.classList.contains('home');

	const updateHeader = () => {
		header.classList.toggle('is-scrolled', !isFront || window.scrollY > 6);
	};

	updateHeader();
	window.addEventListener('scroll', updateHeader, { passive: true });

	if (!burger || !mobileMenu) {
		return;
	}

	let mobileMenuTimer = null;

	const setMobileMenu = (isOpen) => {
		header.classList.toggle('is-mobile-menu-open', isOpen);
		document.body.classList.toggle('has-mobile-menu-open', isOpen);
		burger.setAttribute('aria-expanded', String(isOpen));
		burger.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');

		if (mobileMenuTimer) {
			window.clearTimeout(mobileMenuTimer);
		}

		if (isOpen) {
			mobileMenu.hidden = false;
			window.requestAnimationFrame(() => mobileMenu.classList.add('is-open'));
			return;
		}

		mobileMenu.classList.remove('is-open');
		mobileMenuTimer = window.setTimeout(() => {
			mobileMenu.hidden = !header.classList.contains('is-mobile-menu-open');
		}, 320);
	};

	burger.addEventListener('click', () => {
		setMobileMenu(!header.classList.contains('is-mobile-menu-open'));
	});

	mobileMenu.querySelectorAll('a').forEach((link) => {
		link.addEventListener('click', () => setMobileMenu(false));
	});

	window.addEventListener('keydown', (event) => {
		if (event.key === 'Escape') {
			setMobileMenu(false);
		}
	});

	window.addEventListener('resize', () => {
		if (window.matchMedia('(min-width: 1025px)').matches) {
			setMobileMenu(false);
		}
	});
})();
